import angular from 'angular'
import tpl from './index.html'
import './index.css'

export default angular.module('customerSupportButton', []).component('support', {
  template: tpl,
})
